import { render, staticRenderFns } from "./SparkButton.vue?vue&type=template&id=54679083&scoped=true&"
import script from "./SparkButton.vue?vue&type=script&lang=js&"
export * from "./SparkButton.vue?vue&type=script&lang=js&"
import style0 from "./SparkButton.vue?vue&type=style&index=0&id=54679083&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54679083",
  null
  
)

export default component.exports